import React from 'react'
import SocialAppContainer from '../../../Components/Applications/SocialApp'

export default function SocialApp() {
  return (
    <div className='page-body'>
      <SocialAppContainer />
    </div>
  )
}